import React from "react";
import dayjs from "dayjs";
import { Image } from "antd";
import { useAppSelector } from "../../../../../../util/hooks";
import { currencyBRL } from "../../../../../../util/dinheiroBRAuxiliar";
import { EmpresaModel } from "../../../../../../models/empresa/empresaModel";
import icon from "../../../../../../util/assets/icon_login.png";
import { pivotData } from "../functions/pivotData";
import { sortAnoMes } from "../functions/sortAnoMes";

export const RelatorioComparativoHtml = React.forwardRef<HTMLDivElement>((_props, ref) => {
  //estados globais
  const relatorioState = useAppSelector((state) => state.relatorio);
  const empresaState = useAppSelector((state) => state.empresa);

  const pivotedData = pivotData(relatorioState.listLancamentoFinanceiroPorMes);

  const uniqueAnoMes = sortAnoMes(Array.from(new Set(relatorioState.listLancamentoFinanceiroPorMes.map((item) => item.anoMes))));
  const sortedAnoMes = sortAnoMes(uniqueAnoMes);

  const dataInicioFormatted = dayjs(relatorioState.buscaLancamentoFinanceiro.dataInicio).format("DD/MM/YYYY");
  const dataFimFormatted = dayjs(relatorioState.buscaLancamentoFinanceiro.dataFim).format("DD/MM/YYYY");

  return (
    <div ref={ref} className="relatorios-html-format">
      <div className="rel-cabecalho">
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center", marginTop: "24px", marginBottom: "24px", marginLeft: "14px" }}>
          <Image preview={false} height={50} src={icon} />
          <div className="logoText">
            <div className="labelLogoGeral">
              <span>GRUPO</span>
            </div>
            <div className="labelLogoGeral">
              <span>PASCHOAL</span>
            </div>
          </div>
          <div className="rel-titulo" style={{ display: "flex", flexDirection: "column", marginLeft: "24px" }}>
            <h2>
              <strong>Relatório de Lançamento de Plano de Conta</strong>
            </h2>
            <p>{"Empresa: " + empresaState.list.find((a: EmpresaModel) => a.id === relatorioState.buscaLancamentoFinanceiro.idEmpresa)?.apelido}</p>
            <p style={{ marginTop: "-10px" }}>{`Data Inicial: ${dataInicioFormatted}`}</p>
            <p style={{ marginTop: "-10px" }}>{`Data Final: ${dataFimFormatted}`}</p>
          </div>
        </div>
      </div>
      <div className="rel-detalhes-composicao">
        <table className="tb-dados">
          <thead>
            <tr className="header-table">
              <th className="ht-left">Descrição</th>
              {sortedAnoMes.map((anoMes, index) => (
                <th key={index} className="ht-right">
                  {anoMes.toUpperCase()}
                </th>
              ))}
              <th className="ht-right">Média</th>
            </tr>
          </thead>
          <tbody className="body-table">
            {pivotedData.map((record) => (
              <tr key={record.id}>
                <td className="ht-left" style={{ width: "750px" }}>
                  <div style={{ padding: `2px ${(record.nivel - 1) * 10}px` }}>{`${record.codigo} ${record.denominacao}`}</div>
                </td>
                {sortedAnoMes.map((anoMes, index) => {
                  const cell = record[anoMes];
                  let valor = typeof cell === "object" && cell !== null && "valor" in cell ? (cell as any).valor : Number(cell);
                  return (
                    <td key={index} className="ht-right" style={{ color: valor < 0 ? "red" : "inherit", width: "150px" }}>
                      {currencyBRL(valor)}
                    </td>
                  );
                })}
                <td className="ht-right" style={{ width: "150px" }}>
                  {(() => {
                    const values = sortedAnoMes
                      .map((anoMes) => {
                        const cell = record[anoMes];
                        return typeof cell === "object" && cell !== null && "valor" in cell ? (cell as any).valor : Number(cell);
                      })
                      .filter((val) => val !== undefined && val !== null && !isNaN(val));
                    const total = values.reduce((sum, val) => sum + val, 0);
                    const average = values.length > 0 ? total / values.length : 0;
                    return <span style={{ color: average < 0 ? "red" : "inherit" }}>{currencyBRL(average)}</span>;
                  })()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
});
